import {combineReducers} from 'redux';
import topBanner from './topBanner/reducer';
import navigationBar from './navigationBar/reducer';
import eventPriceDetailsModal from './eventPriceDetailsModal/reducer';
import error from './error/reducer';
import auth from './auth/reducer';

export default combineReducers({
  topBanner,
  navigationBar,
  eventPriceDetailsModal,
  error,
  auth
});



// WEBPACK FOOTER //
// ./src/features/shared/reducer.js